import React from 'react'

import T from 'components/FormattedMessage'
import Currency from 'components/Currency'
import GeneralListItem from 'components/GeneralListItem'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Typography from '@material-ui/core/Typography'

import { PossibleReferralBonusTypeToken } from 'lib/enumTranslations'
import { IReferralBonus } from 'protos'

import tickIconUrl from './assets/tick.svg'

interface Props {
  bonuses: Array<IReferralBonus>
}

const PossibleBonusList = ({ bonuses }: Props) => (
  <List>
    <ListItem divider>
      <Typography variant="caption" color="textSecondary">
        <T id="referrals_section_help_title" />
      </Typography>
    </ListItem>
    {bonuses.map((bonus, i) => (
      <GeneralListItem
        dense
        key={i}
        headline={<T id={PossibleReferralBonusTypeToken(bonus.type!)} />}
        leftChild={<img alt="" src={tickIconUrl} style={{ display: 'block' }} />}
        rightChild={<Typography variant="subtitle1"><Currency value={bonus.value!.value} /></Typography>}
      />
    ))}
  </List>
)

export default PossibleBonusList
try {
    // @ts-ignore
    PossibleBonusList.displayName = "PossibleBonusList";
    // @ts-ignore
    PossibleBonusList.__docgenInfo = { "description": "", "displayName": "PossibleBonusList", "props": { "bonuses": { "defaultValue": null, "description": "", "name": "bonuses", "required": true, "type": { "name": "any[]" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/routes/Friends/FriendsScreen/tabs/InviteFriendsTab/components/PossibleBonusList/PossibleBonusList.tsx#PossibleBonusList"] = { docgenInfo: PossibleBonusList.__docgenInfo, name: "PossibleBonusList", path: "src/routes/Friends/FriendsScreen/tabs/InviteFriendsTab/components/PossibleBonusList/PossibleBonusList.tsx#PossibleBonusList" };
}
catch (__react_docgen_typescript_loader_error) { }